import { compose } from 'ramda';
import { put, PutEffect } from 'redux-saga/effects';
import { EmptyAction, PayloadAction } from 'typesafe-actions';

export const putEmptyAction = <A extends EmptyAction<string>>(
  actionBuilder: () => A
) => compose<A, PutEffect<A>>(put, actionBuilder);

export const putPayloadAction = <A, B extends PayloadAction<string, A>>(
  actionBuilder: (payload: A) => B
) => compose<A, PayloadAction<string, A>, PutEffect<B>>(put, actionBuilder);
